import React from 'react'
import DateTimeRangeFilter, { DateFilterObject } from '../../../../../../common/filter/DateTimeRangeFilter'

interface Props {
  value?: { from?: Date; to?: Date }
  onChange: (v: { from?: Date; to?: Date }) => void
  hideRanges?: boolean
  className?: string
}

const DateRangeFilter: React.FC<Props> = ({ value, onChange, hideRanges, className }) => (
  <DateTimeRangeFilter
    filter={{ dateStart: value?.from ?? null, dateEnd: value?.to ?? null }}
    updateTime={(d: DateFilterObject) => onChange({ from: d.dateStart ?? undefined, to: d.dateEnd ?? undefined })}
    hideRanges={hideRanges}
    className={className}
  />
)

export default DateRangeFilter
